var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3.33366C3 2.41319 3.7462 1.66699 4.66667 1.66699H12.6667C12.8508 1.66699 13 1.81623 13 2.00033V12.0003C13 12.1844 12.8508 12.3337 12.6667 12.3337H4.66667C4.11437 12.3337 3.66667 12.7814 3.66667 13.3337V13.667H12.6667V14.3337H3.33333C3.14924 14.3337 3 14.1844 3 14.0003V3.33366ZM7.66667 8.66699V7.00033H6V6.33366H7.66667V4.66699H8.33333V6.33366H10V7.00033H8.33333V8.66699H7.66667Z",
    fill: "#5571C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordBook);
export default __webpack_public_path__ + "static/media/record_book.399a64a19cbead0a440fedc7a466d774.svg";
export { ForwardRef as ReactComponent };